module.exports = __webpack_public_path__ + "static/media/scoped-suggestion-banner.df11a2ce.png";